import sportsReducer from './sportsReducer';
import leaguesReducer from './leaguesReducer';

export default function menuReducer(menu, action) {
    if (menu === undefined) {
        return menu;
    }

    menu = menu.update('sports', (s) => sportsReducer(s, action));
    menu = menu.update('leagues', (l) => leaguesReducer(l, action));

    return menu;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/menu/menuReducer.js